import React from 'react'
import {bindActionCreators} from 'redux'
import {ItemsCreators} from '../../store/actions/items'
import {connect} from 'react-redux'

import './toast.notification.scss'

const ToastNotification = props => {

  const {
    itemToRemove,
    connectorToRemove,
    message
  } = props

  if (itemToRemove) {
    return (
      <div id="toast-notification" className="toast-notification">
        <span>Bloco <strong>{itemToRemove ? itemToRemove.title : ''}</strong> apagado</span>
      </div>
    )
  } else if (connectorToRemove) {
    return (
      <div id="toast-notification" className="toast-notification">
        <span>Ligação apagada</span>
      </div>
    )
  } else {
    return (
      <div id="toast-notification" className="toast-notification">
        <span>{message}</span>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  items: state.items.list,
  bot: state.bots.bot,
  currentItem: state.items.currentItem
})

const mapDispatchToProps = dispatch => bindActionCreators({...ItemsCreators}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToastNotification)
